import API from '@/api/lib/api'
import baseUrl from '@/api/lib/url'

export const updateWebsiteAboutUs = async (restaurant_id, data) => {
  try {
    const response = await API.put(
      `online-order/settings/restaurant/${restaurant_id}/about`,
      data
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}
export const updateWebsiteContactUs = async (restaurant_id, data) => {
  try {
    const response = await API.put(
      `online-order/settings/restaurant/${restaurant_id}/contact-info`,
      {
        contact_phone: data.phone,
        contact_email: data.email,
        contact_address: data.address,
        happy_customers: data.happy_customers,
        years_of_service: data.years_of_service,
        culinary_awards: data.culinary_awards
      }
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}
export const updateWebsiteTerms = async (restaurant_id, data) => {
  try {
    const response = await API.put(
      `online-order/settings/restaurant/${restaurant_id}/terms-and-conditions`,
      { terms_and_conditions: data }
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

// website setting available time
export const getAllWebsiteSettingAvailableTime = async restaurant_id => {
  try {
    const response = await API.get(
      `online-order/settings/${restaurant_id}/available-times`
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}
export const createWebsiteSettingAvailableTime = async data => {
  try {
    const response = await API.post(
      `online-order/settings/available-times`,
      data
    )
    return response.data
  } catch (error) {
    console.error('Error creating notice:', error)
    return {
      status: 'failure',
      message: error.response?.data.message || 'Something went wrong.'
    }
  }
}

export const updateWebsiteSettingAvailableTime = async (item_id, data) => {
  try {
    const response = await API.put(
      `online-order/settings/available-times/${item_id}`,
      data
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

export const toggleWebsiteSettingAvailableTime = async id => {
  try {
    const response = await API.put(
      `online-order/settings/available-times/${id}/toggle`
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

// fetch all website settings
export const getAllWebsiteSettings = async restaurant_id => {
  try {
    const response = await API.get(
      `online-order/settings/restaurant/${restaurant_id}`
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

export const updateFooterSettings = async (restaurant_id, data) => {
  try {
    const response = await API.put(
      `online-order/settings/restaurant/${restaurant_id}/footer`,
      data
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

export const updateImage = async formData => {
  try {
    const response = await API.post(
      'online-order/settings/restaurant/image-upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

export const uploadWebsiteImage = async (
  file,
  clientId = 1,
  restaurantId = 1
) => {
  const token = localStorage.getItem('token')
  const formData = new FormData()
  formData.append('file', file)
  formData.append('client_id', clientId.toString())
  formData.append('restaurant_id', restaurantId.toString())
  formData.append(
    'directory',
    'online-order/settings/restaurant/website-logo-banner'
  )

  try {
    const res = await fetch(`${baseUrl}utility/file-manager`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    })

    const data = await res.json()
    return data
  } catch (error) {
    return {
      status: 'failure',
      message: error.message || 'Something went wrong.'
    }
  }
}

export const updateWebsiteImageInfo = async (
  restaurantId,
  imageType,
  fileId
) => {
  try {
    const response = await API.put(
      `online-order/settings/restaurant/${restaurantId}/update-image`,
      {
        image_type: imageType,
        file_manager_id: fileId
      }
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

export const getWebsiteCardSettings = async restaurant_id => {
  try {
    const response = await API.get(
      `online-order/settings/restaurant/${restaurant_id}/menu-card-settings`
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: error.message || 'Something went wrong.'
      }
    )
  }
}

export const updateWebsiteCardSettings = async (restaurant_id, data) => {
  try {
    const response = await API.put(
      `online-order/settings/restaurant/${restaurant_id}/menu-card-settings`,
      data
    )
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: error.message || 'Something went wrong.'
      }
    )
  }
}
